import {
  ITranslationSyncState,
  ITranslationSyncStatus,
} from "../../../@types/admin/AdminMasterTranslations";

/** Human label for one language's sync state. */
export function syncStateLabel(state: ITranslationSyncState): string {
  switch (state) {
    case "InSync":
      return "In sync";
    case "Different":
      return "Different";
    case "Missing":
    default:
      return "Missing";
  }
}

/** StatusBadge variant for one language's sync state. */
export function syncStateBadge(
  state: ITranslationSyncState
): "active" | "warning" | "error" {
  switch (state) {
    case "InSync":
      return "active";
    case "Different":
      return "warning";
    case "Missing":
    default:
      return "error";
  }
}

export interface IKeySyncSummary {
  total: number;
  inSync: number;
  different: number;
  missing: number;
  /** True when at least one language is Different or Missing. */
  needsSync: boolean;
}

/** Rolls one key's per-language states up into the list row's summary. */
export function summarizeKeyStatus(
  status: ITranslationSyncStatus
): IKeySyncSummary {
  const total = status.languages.length;
  const inSync = status.languages.filter((l) => l.state === "InSync").length;
  const different = status.languages.filter(
    (l) => l.state === "Different"
  ).length;
  const missing = status.languages.filter((l) => l.state === "Missing").length;

  return { total, inSync, different, missing, needsSync: inSync < total };
}

/** "2 missing, 1 different" / "in sync" — the list row's status text. */
export function keyStatusText(summary: IKeySyncSummary): string {
  if (!summary.needsSync) return "In sync";

  const parts: string[] = [];
  if (summary.missing > 0) parts.push(`${summary.missing} missing`);
  if (summary.different > 0) parts.push(`${summary.different} different`);
  return parts.join(", ");
}

export function keyStatusBadge(
  summary: IKeySyncSummary
): "active" | "warning" | "error" {
  if (!summary.needsSync) return "active";
  return summary.missing === summary.total ? "error" : "warning";
}
